import videojs from "video.js";
import "./video-player.scss";

const players = document.querySelectorAll("[data-dse-video-player]");

players.forEach((player) => {
  videojs(player as HTMLElement, {
    controls: true,
    autoplay: false,
  });
});
